<template>
  <div class="box">
    <div class="banner">
      <img :src="banner" alt="">
      <div class="banner-text">
        <h6 class="banner-text-h6">购物管理系统</h6>
        <!-- <h6 class="banner-text-h6">趣旅淘系统</h6> -->
        <!-- <p class="banner-text-p">每一位导游都是您的销售员</p> -->
        <p class="banner-text-p">哪里有趣哪里淘</p>
        <!-- <h6 class="banner-text-h6">南部非洲环游记</h6>
        <p class="banner-text-p">观动物大迁徒，跟随当地向导体验原生态生活</p> -->
      </div>
      <div class="banner-btn">
        <div class="info"><a   :href="'#/withgroup'" >查看详情</a></div>
        <!-- <div class="try">申请试用</div> -->
        <router-link  :to="{path:'/league',query: {sysTtype:sysTtype}}"><div class="try">申请试用</div></router-link>
      </div>
    </div>
    <div class="center clearfix">
        <div class="indexCase clearfix">
          <div class="indexTitle-box">
            <h5 class="indexTitle">热门<span class="obj-color">推荐</span></h5>
            <!-- <h6 class="indexSubtitle">Service scope </h6> -->
          </div>
          <ul class="hot">
            <li class="hot-li">
              <div class="img-box">
                <img :src="hotImg+'1.jpg'" alt="">
              </div>
              <p>虎穴寺(Den temple)</p>
              <span>不丹景点</span>
              <div class="hot-er">
                <div class="img-er">
                  <img :src="er_img" alt="">
                  <div>扫码查看更多</div>
                </div>
              </div>
            </li>
            <li class="hot-li">
              <div class="img-box">
                <img :src="hotImg+'2.jpg'" alt="">
              </div>
              <p>徒步旅行经验及注意事项</p>
              <span>锦囊</span>
              <div class="hot-er">
                <div class="img-er">
                  <img :src="er_img" alt="">
                  <div>扫码查看更多</div>
                </div>
              </div>
            </li>
            <li class="hot-li">
              <div class="img-box">
                <img :src="hotImg+'3.jpg'" alt="">
              </div>
              <p>新加坡良木园酒店</p>
              <span>新加坡住宿</span>
              <div class="hot-er">
                <div class="img-er">
                  <img :src="er_img" alt="">
                  <div>扫码查看更多</div>
                </div>
              </div>
            </li>
            <li class="hot-li">
              <div class="img-box">
                <img :src="hotImg+'4.jpg'" alt="">
              </div>
              <p>奥兰多迪士尼世界</p>
              <span>奥兰多休闲</span>
              <div class="hot-er">
                <div class="img-er">
                  <img :src="er_img" alt="">
                  <div>扫码查看更多</div>
                </div>
              </div>
            </li>
            <li class="hot-li">
              <div class="img-box">
                <img :src="hotImg+'5.jpg'" alt="">
              </div>
              <p>皇冠赌场(Crown casino)</p>
              <span>墨尔本休闲</span>
              <div class="hot-er">
                <div class="img-er">
                  <img :src="er_img" alt="">
                  <div>扫码查看更多</div>
                </div>
              </div>
            </li>
            <li class="hot-li">
              <div class="img-box">
                <img :src="hotImg+'6.jpg'" alt="">
              </div>
              <p>银座(Ginza)</p>
              <span>东京购物</span>
              <div class="hot-er">
                <div class="img-er">
                  <img :src="er_img" alt="">
                  <div>扫码查看更多</div>
                </div>
              </div>
            </li>
            <li class="hot-li">
              <div class="img-box">
                <img :src="hotImg+'7.jpg'" alt="">
              </div>
              <p>秋叶原(Akihabara)</p>
              <span>东京购物</span>
              <div class="hot-er">
                <div class="img-er">
                  <img :src="er_img" alt="">
                  <div>扫码查看更多</div>
                </div>
              </div>
            </li>
            <li class="hot-li">
              <div class="img-box">
                <img :src="hotImg+'8.jpg'" alt="">
              </div>
              <p>宫廷啤酒屋</p>
              <span>慕尼黑美食</span>
              <div class="hot-er">
                <div class="img-er">
                  <img :src="er_img" alt="">
                  <div>扫码查看更多</div>
                </div>
              </div>
            </li>
 
          </ul>
          <!-- <ul class="indexService">
            <li class="indexService-li">
              <img :src="indexServiceIcon+'1.png'" alt="">
              <p>旅游线路</p>
            </li>
            <li class="indexService-li">
              <img :src="indexServiceIcon+'2.png'" alt="">
              <p>旅游定制</p>
            </li>
            <li class="indexService-li">
              <img :src="indexServiceIcon+'3.png'" alt="">
              <p>攻略查询</p>
            </li>
            <li class="indexService-li">
              <img :src="indexServiceIcon+'4.png'" alt="">
              <p>向导服务</p>
            </li>
            <li class="indexService-li">
              <img :src="indexServiceIcon+'5.png'" alt="">
              <p>带团工具</p>
            </li>
            <li class="indexService-li">
              <img :src="indexServiceIcon+'6.png'" alt="">
              <p>游记分享</p>
            </li>
          </ul> -->
        </div>
        <!-- <div class="indexCase clearfix">
          <div class="indexTitle-box">
            <h5 class="indexTitle">关于我们</h5>
            <h6 class="indexSubtitle">About us</h6>
          </div>
          <div class="clearfix">
            <img :src="indexAbout" alt="" class="indexAbout-img fr">
            <div class="indexAbout-textBox">
              <h2 class="indexAbout-NameEn">WIICENT</h2>
              <h2 class="indexAbout-NameCn">广州市位讯信息科技有限责任公司</h2>
              <p class="indexAbout-text">位讯旅游致力于为旅行者提供基于位置的全球旅游咨讯和服务。这里有您信赖的导游，提供从需求到结束的全程服务。这里有覆盖两百多个国家和地区的路线、景点、玩法、锦囊、美食、购物、住宿、交通等信息供您查阅。诚邀您一起来分享更多准确、精彩的内容！</p>
            </div>
          </div>
        </div> -->
      </div>
    </div>
</template>

<script>
import Top from '@/components/public/top'
import Bottom from '@/components/public/footer'
import global_ from './../store/global'
export default {
  name: 'Index',
  data () {
    return {
      sendSelected:'index',
      colourClass:'',
      // banner
      banner: global_.imgUrl+'banner.jpg',
      indexServiceIcon: global_.imgUrl+'Service-icon',
      hotImg: global_.imgUrl+'hot_',
      indexAbout: global_.imgUrl+'indexAbout.jpg',
      er_img: global_.imgUrl+'index_er.jpg',
      sysTtype:1,
    }
  },
  mounted(){
    this.$emit('nav',this.sendSelected,this.colourClass);
  }
}
</script>

<style lang="scss" scoped>
  .banner{
    width: 100%;
    min-width: 1200px;
    height: 520px;
    position: relative;
    overflow: hidden;
    img{
      width: 1920px;
      max-width: inherit;
      position: relative;
      left: 50%;
      top: 0;
      margin-left: -960px;
    }
    .banner-text{
      position: absolute;
      height: 100%;
      width: 1200px;
      top: 0;
      left: 50%;
      margin-left: -600px;
      text-align: center;
      color: #fff;
      .banner-text-h6{
        font-size: 42px;
        font-weight: 100;
        margin-top: 200px;
        line-height: 70px;
      }
      .banner-text-p{
        font-size: 20px;
        font-weight: 100;
        margin-top: -10px;
        line-height: 70px;
      }
    }
  }
  .indexCase{
    margin: 50px 0 50px;
    .indexTitle-box{
      margin-bottom: 40px;
      text-align: center;
      .indexTitle{
        font-size: 34px;
        // font-weight: bold;
        color: #333;
        line-height: 40px;
      }
      .obj-color{
        color:#28c188;
      }
      .indexSubtitle{
        font-size: 24px;
        color: #999;
        line-height: 32px;
        font-weight: normal;
        text-transform:uppercase;
        margin: 5px 0;
      }
    }
    .indexService{
      margin: 60px 0 0;
      display: flex;
      .indexService-li{
        flex-grow: 1;
        text-align: center;
        width: 284px;
        height: 238px;
        margin-right: 20px;
        
        img{
          display: block;
          margin: 30px auto 50px;
        }
        p{
          font-size: 20px;
          line-height: 28px;
          color: #333;
          margin: 20px 0 0;
          // text-indent: 15px;
        }
        span{
          font-size: 14px;
        }
      }
    }
    .indexAbout-img{
      margin-left: 40px;
    }
    .indexAbout-textBox{
      margin-right: 530px;
      .indexAbout-NameEn{
        font-size: 24px;
        line-height: 48px;
        color: #999;
        text-transform:uppercase;
      }
      .indexAbout-NameCn{
        font-size: 24px;
        line-height: 38px;
        color: #ff8c00;
        border-bottom: 1px solid #eee;
        padding-bottom: 10px;
      }
      .indexAbout-text{
        font-size: 18px;
        line-height: 36px;
        color: #666;
        margin: 15px 0;
      }
    }
  }
    .hot{
      width: 1200px;
      height: 500px;
      // margin: 60px 0 0;
      display: flex;
      flex-wrap:wrap;
      overflow: hidden;
      .hot-li{
        position: relative;
        display: inline-block;
        text-align: center;
        width: 284px;
        height: 238px;
        // box-shadow:0px 14px 10px -15px #ccc;
        box-shadow:0px 1px 5px 0px #eee;
        margin-right: 15px;
        // cursor: pointer;
        .hot-er{
          width:100%;
          height:100%;
          position: absolute;
          top: 0px;
          background-color:rgba(0,0,0,0.5);
          overflow: hidden;
          display: none;
          .img-er{
            width: 120px;
            height: 170px;
            position: absolute;
            top: 0;
            left:0;
            bottom:0;
            right:0;
            margin: auto;        
            div{
              color: #fff;
              font-size: 12px;
              margin-top: 15px;
            }
          }
        
        }
        &:hover .hot-er{
          display: block;
        }
        // border-bottom: 2px solid #f3f3f3;
        .img-box{
          width:284px;
          height: 160px;
          cursor: pointer;
          img{
            display: block;
            // margin: 30px auto 50px;
            width: 100%;
            height: 100%;
          }
        }

        p{
          font-size: 20px;
          line-height: 28px;
          color: #333;
          margin: 10px 0;
          // text-indent: 15px;
        }
        span{
          font-size: 14px;
          margin-top: 4px;
          color:#a9a9a9;
        }
      }
    }
    .banner-btn{
      width:440px;
      height: 52px;
      position: absolute;
      top: 250px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      margin: auto;
      text-align: center;
      color: #fff;
      .info,.try{
        width: 200px;
        height: 52px;
        line-height: 52px;
        text-align: center;
        float: left;
        border-radius: 2px;
        background: linear-gradient(to right, #ff4d67 0%,#ff914d 100%);
        cursor: pointer;
      }
      .try{
        margin-left: 34px;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/index.vue